import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    lists: {},
    error: '',
    list: {},
    updated_id: ''
}
const mutations = {
    SET_DATAS(state, lists) {
        state.lists = lists.user_role_list
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
    },
    LIST_DATA(state, list) {
        state.list = list
    },
}
const actions = {
    fetchLists({
        commit,
        rootState
    }, data) {

        return AppService.userrole.getUserRoles(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.userrole.postUserRole(list, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.userrole.postUserRoleUpdate(field, id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchList({
        commit,
        rootState
    }, id) {

        return AppService.userrole.getUserRole(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteuserrole({
        commit,
        rootState
    }, data) {

        return AppService.userrole.getUserRoleDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions
}